import PropTypes from 'prop-types';
import React from 'react';
//import BigPicture from 'react-bigpicture';
import styled from 'styled-components';
import { slugify } from '../../utils/functions';
import LighboxItem from '../Media/Lightbox';
import { shuffle } from '../../utils/functions';
import { clientTitle } from '../../utils/prismic';

const GalleryList = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: space-between;
  .galleryItem {
    position: relative;
    flex-grow: 1;
    flex-shrink: 1;
    width: 400px;
    height: 400px;
  }
`;

export const ListPortfolio = ({ projects }) => {
  const source = projects && shuffle(projects);

  const projectList = source.map(({ data }, index) => {
    const type =
      data && data.seo_video && data.seo_video.url ? 'video' : 'image';
    const title = data.seo_title + clientTitle(data);
    const image = data && data.seo_thumbnail;
    const video = data && data.seo_video;

    const id = slugify(index + '_' + type + '-' + title);

    return (
      <LighboxItem
        title={title}
        type={type}
        imageUrl={image && image.url}
        imageAlt={image && image.alt}
        video={video & video.url}
        isHidden={image && image.url}
        className="galleryItem"
        id={id}
        key={id}
      />
    );
  });

  return <GalleryList>{projectList}</GalleryList>;
};

ListPortfolio.propTypes = {
  projects: PropTypes.array.isRequired,
  itemWidth: PropTypes.number,
};

export default ListPortfolio;
